export default "__VITE_ASSET__11679331__"